import { Icon, Button } from 'semantic-ui-react';
import { S } from './yearMonthPickerStyles';

export const YearMonthPickerNavigation = ({
  currentYearPage,
  navigationYear,
  yearPages,
  setCurrentYearPage,
  setNavigationYear,
  mode,
  minYear,
  maxYear,
}: {
  currentYearPage: number;
  navigationYear: number;
  yearPages: number[][];
  mode: 'year' | 'month';
  minYear: number;
  maxYear: number;
  setCurrentYearPage: (page: number) => void;
  setNavigationYear: (year: number) => void;
}) => {
  const canNavigatePrev = mode === 'year' ? currentYearPage > 0 : navigationYear > minYear;
  const canNavigateNext =
    mode === 'year' ? currentYearPage < yearPages.length - 1 : navigationYear < maxYear;

  const handleNavigatePrev = () => {
    if (mode === 'year') {
      setCurrentYearPage(Math.max(currentYearPage - 1, 0));
    } else {
      setNavigationYear(Math.max(navigationYear - 1, minYear));
    }
  };

  const handleNavigateNext = () => {
    if (mode === 'year') {
      setCurrentYearPage(Math.min(currentYearPage + 1, yearPages.length - 1));
    } else {
      setNavigationYear(Math.min(navigationYear + 1, maxYear));
    }
  };

  const getNavigationTitle = () => {
    if (mode === 'year') {
      const page = yearPages[currentYearPage];
      if (page && page.length > 0) {
        return `${page[0]} - ${page.at(-1)}`;
      }
      return 'Select Year';
    }
    return navigationYear;
  };

  return (
    <S.MenuHeader secondary attached="top">
      <Button
        icon
        basic
        size="mini"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleNavigatePrev();
        }}
        disabled={!canNavigatePrev}
      >
        <Icon name="chevron left" />
      </Button>
      <span>{getNavigationTitle()}</span>
      <Button
        icon
        basic
        size="mini"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleNavigateNext();
        }}
        disabled={!canNavigateNext}
      >
        <Icon name="chevron right" />
      </Button>
    </S.MenuHeader>
  );
};
